import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'simple-dialog',
  templateUrl: './simple-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./simple-dialog.component.scss']
})
export class SimpleDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

}
